<script setup>

const props = defineProps({
  title: {
    type: String,
    default: 'So einfach ist die Fotobox-Miete'
  },
  subtitle: {
    type: String,
    default: 'Ihre Fotobox für unvergessliche Momente.'
  },
  steps: {
    type: Array,
    default: () => [
      {
        number: 1,
        title: 'Anfrage stellen',
        description: 'Kontaktieren Sie uns mit Ihrem Wunschtermin und Ihren Vorstellungen.'
      },
      {
        number: 2,
        title: 'Individuelles Angebot',
        description: 'Sie erhalten von uns ein maßgeschneidertes Angebot für Ihre Veranstaltung.'
      },
      {
        number: 3,
        title: 'Genießen & Erinnern',
        description: 'Wir liefern, bauen auf und betreuen - Sie und Ihre Gäste genießen.'
      }
    ]
  },
  locationName: {
    type: String,
    default: ''
  }
})

const displaySubtitle = computed(() => {
  if (props.locationName) {
    return `Ihre Fotobox für unvergessliche Momente in ${props.locationName}.`
  }
  return props.subtitle
})
</script>

<template>
  <section class="py-16 bg-gray-50">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h2 class="heading-2 mb-4">{{ title }}</h2>
        <p class="text-lg text-gray-600 max-w-3xl mx-auto">{{ displaySubtitle }}</p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div v-for="step in steps" :key="step.number" class="bg-white p-6 rounded-lg shadow text-center">
          <div class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <span class="text-primary text-2xl font-bold">{{ step.number }}</span>
          </div>
          <h3 class="text-xl font-semibold mb-2">{{ step.title }}</h3>
          <p class="text-gray-600">{{ step.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>